import { CheckoutStates } from 'components/DSO/DSOOrderCheckout/DSOOrderCheckout.types';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCheckoutService } from 'services';

export const useDsoSaveOrderShippingMethod = (
  setOrderStep: Dispatch<SetStateAction<CheckoutStates>>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    (shippingMethodId: string) => {
      return dsoCheckoutService.saveOrderShippingMethod(shippingMethodId);
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
        setOrderStep('payment');
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
